const NS = 'PodcastLandingListItemWidget';
const CLS = 'podcastLandingListItemWidget';

import { utils } from '../../../../global/js/utils';
import { handleTruncate } from '../../../../global/js/truncate';

export class PodcastLandingListItemWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.$element.on('click', `.${CLS}-col--left`, (e) => {
			if(utils.checkBP('md')) {
				$(e.currentTarget).toggleClass('show');
				this.$element.find(`.${CLS}-col--middle, .${CLS}-col--right`).toggleClass('show');
			}
		});

		this.limit = 250; // reserved limit (characters)
		this.$summary = this.$element.find(`.${CLS}-summary`);
		this.summaryHtml = this.$summary.html();
		this.summaryText = this.$summary.text(); // for comparison without the extra characters from html tags
		this.originalHtml = this.summaryHtml;

		// handle truncate (read more / read less)
		handleTruncate(this);
	}
}
